var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Autocomplete, Box, Button, FormControl, MenuItem, Select, selectClasses, styled, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { SearchFilterTypeURL } from '../../api/url';
import { getByIdAPI, resetState } from '../../redux/crudSlice';
import { useAppDispatch } from '../../store/hooks';
import { REG } from '../../utils/validationHelper';
import { MuiStack } from '../atoms/stackComponent';
import './molecules.css';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/storageHelper';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import { Search } from '../../builderPackage/assets/svg';
import { KeyboardArrowDownRounded } from '@mui/icons-material';
import { RoundClearIcon } from '../../assets/customIcons';
var data = [
    // { label: 'Customer name', value: 'Customer name' },
    {
        label: 'Mobile',
        value: 'Mobile'
    }, {
        label: 'Email',
        value: 'Email'
    }, {
        label: 'VIN no',
        value: 'VIN no.'
    }, {
        label: 'Reg. no',
        value: 'Reg. no.'
    }
];
var InputBox = styled(TextField)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& fieldset": {
            border: "1px solid #DEE4EB",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        },
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                border: "1px solid #DEE4EB",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            },
            backgroundColor: "#F4F7FA",
            borderRadius: "8px"
        }
    };
});
var SearchStateE = /*#__PURE__*/ function (SearchStateE) {
    SearchStateE["toSearch"] = "toSearch";
    SearchStateE["searching"] = "searching";
    SearchStateE["searchComplete"] = "searchComplete";
    return SearchStateE;
}(SearchStateE || {});
var SearchBarByTypes = function (props) {
    var handleSelectSearchType = props.handleSelectSearchType, handleSearchTextChange = props.handleSearchTextChange, handleSelectSearchResult = props.handleSelectSearchResult, selectedOption = props.selectedOption, searchText = props.searchText, autocompleteOptions = props.autocompleteOptions, handleOnClickSearchIcon = props.handleOnClickSearchIcon, SearchState = props.SearchState, SystemName = props.SystemName, Value = props.Value;
    var _a = React.useState(Value !== null && Value !== void 0 ? Value : ''), inputValue = _a[0], setInputValue = _a[1];
    var _b = React.useState(autocompleteOptions), autoCompleteList = _b[0], setAutoCompleteList = _b[1];
    var _c = React.useState([]), searchTypeList = _c[0], setSearchTypeList = _c[1];
    var _d = useState(false), isFocused = _d[0], setIsFocused = _d[1];
    var dispatch = useAppDispatch();
    var searchInstallBaseByTypesList = getLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH_INSTALLBASE_BY_TYPES_LIST);
    var handleSearchChange = function (event) {
        var _event$target$value;
        handleSearchTextChange((_event$target$value = event.target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "");
        setAutoCompleteList([]);
        dispatch(resetState(["getModuleHeaderCount", "getStoredJobItems", "getCustomerInfo", "customerComplaintDataImageAndAudio", "documentDetailsGetById", "preDocumentFetch", "customerDetailsTrnalsteToJob", "savedJobItemCreateFlow", "customerComplaintInitialvaluesLength"]));
    };
    var handleSearchTypeChange = function (event) {
        handleSelectSearchType(event.target.value);
        setInputValue("");
    };
    useEffect(function () {
        searchTypeAPI();
        dispatch(resetState(["customerComplaintInitialvaluesLength"]));
    }, []);
    var searchTypeAPI = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, _Result$payload, Result, _Result$payload2, _Result$payload3, updatedList;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    request = {
                        SystemName: SystemName
                    };
                    if (!(searchInstallBaseByTypesList && searchInstallBaseByTypesList[SystemName] && searchInstallBaseByTypesList[SystemName].length > 0)) return [3 /*break*/, 1];
                    setSearchTypeList(searchInstallBaseByTypesList[SystemName]);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'getSearchTypeList',
                        url: SearchFilterTypeURL,
                        request: request
                    }))];
                case 2:
                    Result = _b.sent();
                    if (Result !== null && Result !== void 0 && (_Result$payload = Result.payload) !== null && _Result$payload !== void 0 && (_Result$payload = _Result$payload.value) !== null && _Result$payload !== void 0 && _Result$payload.success) {
                        updatedList = _objectSpread(_objectSpread({}, searchInstallBaseByTypesList), {}, (_a = {},
                            _a[SystemName] = Result === null || Result === void 0 || (_Result$payload2 = Result.payload) === null || _Result$payload2 === void 0 || (_Result$payload2 = _Result$payload2.value) === null || _Result$payload2 === void 0 || (_Result$payload2 = _Result$payload2.data[0]) === null || _Result$payload2 === void 0 ? void 0 : _Result$payload2.FilterValues,
                            _a));
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH_INSTALLBASE_BY_TYPES_LIST, updatedList);
                        setSearchTypeList(Result === null || Result === void 0 || (_Result$payload3 = Result.payload) === null || _Result$payload3 === void 0 || (_Result$payload3 = _Result$payload3.value) === null || _Result$payload3 === void 0 || (_Result$payload3 = _Result$payload3.data[0]) === null || _Result$payload3 === void 0 ? void 0 : _Result$payload3.FilterValues);
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setAutoCompleteList(autocompleteOptions);
        return function () {
            setAutoCompleteList([]);
        };
    }, [autocompleteOptions]);
    var onClickSearchBtn = function () {
        handleOnClickSearchIcon(inputValue);
    };
    var getSearchDisable = function () {
        var isDisabled = false;
        switch (selectedOption) {
            case "MobileNumber":
                isDisabled = inputValue.length >= 3;
                break;
            case "Email":
                isDisabled = inputValue.length >= 3;
                break;
            case "VinNo":
                isDisabled = inputValue.length >= 17;
                break;
            case "RegistrationNo":
                isDisabled = inputValue.length >= 4;
                break;
            default:
                isDisabled = false;
        }
        return !isDisabled;
    };
    var onInputFocus = function () {
        setIsFocused(true);
    };
    var onInputBlur = function () {
        setIsFocused(false);
    };
    return /*#__PURE__*/ React.createElement(FormControl, null, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: 'row',
        spacing: 1,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Autocomplete, {
        sx: {
            maxWidth: {
                xs: '100%',
                sm: '328px',
                md: '328px'
            }
        },
        clearIcon: /*#__PURE__*/ React.createElement(RoundClearIcon, {
            sx: {
                width: 18,
                height: 18
            }
        }),
        className: "custume-auto-complete",
        open: autocompleteOptions.length > 0 && SearchState !== SearchStateE.searchComplete,
        id: "create-input",
        fullWidth: true,
        size: "small",
        autoHighlight: true,
        options: autoCompleteList,
        getOptionLabel: function (option) {
            switch (selectedOption) {
                case "MobileNumber":
                    return option.MobileNumber;
                case "Email":
                    return option.Email;
                case "VinNo":
                    return option.VINNo;
                case "RegistrationNo":
                    return option.RegNo;
                default:
                    return "";
            }
        },
        renderOption: function (props, option) { /*#__PURE__*/ return React.createElement(Box, _extends({
            component: "li",
            sx: {
                '& > img': {
                    mr: 2,
                    flexShrink: 0
                }
            }
        }, props), /*#__PURE__*/ React.createElement("div", {
            style: {
                padding: "5px 10px"
            }
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                fontSize: "14px"
            }
        }, /*#__PURE__*/ React.createElement("b", null, option === null || option === void 0 ? void 0 : option.GivenName, " ", option === null || option === void 0 ? void 0 : option.FamilyName)), /*#__PURE__*/ React.createElement("div", {
            style: {
                fontSize: "14px",
                textWrap: "pretty"
            }
        }, selectedOption === "MobileNumber" ? option.MobileNumber : option.Email))); }
        //     <>
        // <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
        //   <MuiStack spacing={1} alignItems={'center'}>
        //       {/* <Typography variant='h2' id="given-name">{option?.GivenName + " " + option?.FamilyName}</Typography> */}
        //       <Typography variant='h2' id="given-name">{option?.GivenName}</Typography>
        //       <Typography variant='h2' id="given-name">{option?.FamilyName}</Typography>
        //     </MuiStack>
        // </Box>
        //   <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }}{...props} >
        //     <Typography variant='body2' id="selected-value" sx={{ color: '#8593A3', wordBreak: 'break-word', whiteSpace: 'pre', }} >{selectedOption === "MobileNumber" ? option.MobileNumber : option.Email}</Typography>
        //   </Box>
        // </>
        ,
        onChange: function (event, newValue) {
            var _newValue$PersonId, _newValue$Email, _newValue$VINNo, _newValue$RegNo;
            var selectedValue = "";
            switch (selectedOption) {
                case "MobileNumber":
                    selectedValue = (_newValue$PersonId = newValue === null || newValue === void 0 ? void 0 : newValue.PersonId) !== null && _newValue$PersonId !== void 0 ? _newValue$PersonId : "";
                    break;
                case "Email":
                    selectedValue = (_newValue$Email = newValue === null || newValue === void 0 ? void 0 : newValue.Email) !== null && _newValue$Email !== void 0 ? _newValue$Email : "";
                    break;
                case "VinNo":
                    selectedValue = (_newValue$VINNo = newValue === null || newValue === void 0 ? void 0 : newValue.VINNo) !== null && _newValue$VINNo !== void 0 ? _newValue$VINNo : "";
                    break;
                case "RegistrationNo.":
                    selectedValue = (_newValue$RegNo = newValue === null || newValue === void 0 ? void 0 : newValue.RegNo) !== null && _newValue$RegNo !== void 0 ? _newValue$RegNo : "";
                    break;
                default:
                    break;
            }
            if (selectedValue !== "") {
                handleSelectSearchResult(selectedValue);
            }
        },
        inputValue: inputValue || searchText,
        onInputChange: function (event, newInputValue) {
            if (selectedOption === "MobileNumber" && (newInputValue === null || newInputValue === void 0 ? void 0 : newInputValue.length) <= 10) {
                var value_1 = newInputValue.replace(REG.nonNumericNumber, '');
                setInputValue(value_1);
            }
            var value = newInputValue.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
            var regex = newInputValue.replace(/[^A-Za-z0-9]/g, '');
            if (selectedOption === "Email") {
                setInputValue(value === null || value === void 0 ? void 0 : value.trim());
            }
            if (selectedOption === "VinNo" && (value === null || value === void 0 ? void 0 : value.length) <= 17) {
                setInputValue(regex === null || regex === void 0 ? void 0 : regex.trim());
            }
            if (selectedOption === "RegistrationNo" && (value === null || value === void 0 ? void 0 : value.length) <= 12) {
                setInputValue(regex === null || regex === void 0 ? void 0 : regex.trim());
            }
            if (newInputValue.length === 0) {
                handleSearchChange(event);
            }
        },
        freeSolo: true,
        renderInput: function (params) {
            var _a;
            return React.createElement(TextField, _extends({}, params, {
                id: "searchby-Type" + searchText,
                name: "custume-auto",
                value: searchText,
                onChange: handleSearchChange,
                variant: "outlined",
                focused: false,
                className: isFocused ? "focused-autocomplete" : "default-autocomplete",
                inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
                    inputMode: selectedOption === "MobileNumber" ? 'numeric' : 'text',
                    style: {
                        padding: '2px 0px',
                        maxWidth: '100%'
                    }
                }),
                InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
                    autoComplete: 'new-password',
                    // disable autocomplete and autofill
                    startAdornment: /*#__PURE__*/ React.createElement(Select, {
                        variant: "standard",
                        disableUnderline: true,
                        MenuProps: {
                            disableScrollLock: true
                        },
                        className: "custume-select-auto",
                        value: selectedOption,
                        onChange: handleSearchTypeChange,
                        id: 'searchVehicleDropDown',
                        sx: (_a = {
                                minWidth: '10ch'
                            },
                            _a[".".concat(selectClasses.icon)] = {
                                top: 0
                            },
                            _a),
                        SelectDisplayProps: {
                            style: {
                                minHeight: 'auto',
                                lineHeight: '20px',
                                fontSize: '14px',
                                padding: '0px 4px 0px 0px'
                            }
                        },
                        IconComponent: KeyboardArrowDownRounded
                    }, searchTypeList === null || searchTypeList === void 0 ? void 0 : searchTypeList.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
                        id: item.Value,
                        key: index,
                        value: item.Value
                    }, item.DisplayName); }))
                }),
                onKeyDown: function (event) {
                    if (event.key === 'Enter') {
                        event.stopPropagation();
                        // setInputValue('')
                        return false;
                    }
                },
                onFocus: onInputFocus,
                onBlur: onInputBlur
            }));
        }
    }), /*#__PURE__*/ React.createElement(Button, {
        onClick: onClickSearchBtn,
        disabled: getSearchDisable(),
        id: "search-btn",
        size: "icon"
        // sx={{ p:0 }}
        ,
        color: "secondary",
        variant: "outlined"
    }, /*#__PURE__*/ React.createElement(Search, {
        id: "search-icon"
    }))));
};
export default SearchBarByTypes;
